export enum LicensePacksTableAccessors {
  Name = 'name',
  Licenses = 'licenses',
  Price = 'price',
}
